// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"190":"0058b616","208":"0058b616","246":"0058b616","439":"0058b616","510":"0058b616","540":"0058b616","716":"0058b616"}[chunkId] + ".chunk.css";
};